import React, { useState } from "react";
import GestionMacros from "./GestionMacros";
import GestorMacros from "./GestorMacros"
import GestorArchivos from "./GestorArchivos"
import GestionArchivos from "./GestionArchivos";

const PrincipalGestion = () => {
    const [gestionarMacros, setGestionarMacros] = useState(false);
    const [gestionarArchivos, setGestionarArchivos] = useState(false);

    return (
        <main>
            {
                gestionarMacros ? (
                    <GestorMacros setGestionarMacros={setGestionarMacros} />
                ) : gestionarArchivos ? (
                    <GestorArchivos setGestionarArchivos={setGestionarArchivos}/>
                ) : (
                    <div class="row d-flex  align-items-center justify-content-center flex-grow-1">
                        <div class="col-6">
                            <GestionMacros setGestionarMacros={setGestionarMacros} />
                        </div>
                        <div class="col-6">
                            <GestionArchivos setGestionarArchivos={setGestionarArchivos} />
                        </div>
                    </div>
                )
            }
        </main >
    );
}

export default PrincipalGestion